

class Url {

	isValid(url) {
		try {
			var verifiedUrl = new URL(url);
		  	return verifiedUrl.protocol === "http:" || verifiedUrl.protocol === "https:";
  		} catch (e) {
		    return false;  
		}
	}


	isValidHostname(url,hostname) {
		try {
			var verifiedUrl = new URL(url);
		  	return (verifiedUrl.protocol === "http:" || verifiedUrl.protocol === "https:") && (verifiedUrl.hostname === hostname);
  		} catch (_) {
		    return false;  
		}
	}
}

export default new Url();